import type { UnitType } from "@/types/database";

// unit_details.unit_type is NOT NULL with a narrower 5-value CHECK than
// site-builder's org_profiles.unit_type (widened to 9 across BSA/Girl Scouts/
// Trail Life/AHG). A unit_details row can therefore only be created for one of
// these five; reconciling the wider set is a separate, already-flagged
// cross-repo decision (see scoutingops-supabase's
// 20260715162937_website_admin_settings.sql), not something to resolve here.
export const UNIT_DETAILS_UNIT_TYPES = [
  "cub_scout_pack",
  "scouts_bsa_troop",
  "venturing_crew",
  "sea_scout_ship",
  "exploring_post",
] as const;

export type UnitDetailsUnitType = (typeof UNIT_DETAILS_UNIT_TYPES)[number];

// Narrow a site-builder UnitType down to one unit_details will accept, or null
// when it can't be represented there (a non-BSA type, or nothing set yet).
export function toUnitDetailsUnitType(value: UnitType | null | undefined): UnitDetailsUnitType | null {
  return value && (UNIT_DETAILS_UNIT_TYPES as readonly string[]).includes(value)
    ? (value as UnitDetailsUnitType)
    : null;
}
